var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgActionTabBarBudgetIconOnlyDefault = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 21,
    viewBox: "0 0 35 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h35v21H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1B7690",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.718 4.139C6.24 8.41 6.72 14.74 10.798 18.413l6.071-7.606L9.72 4.14zM17.454.466h-.045a9.908 9.908 0 0 0-7.121 3.043l7.166 6.684V.466zM17.993 10.761l-6.536 8.19c4.438 3.365 10.704 2.397 13.987-2.151a10.494 10.494 0 0 0 1.964-6.039h-9.415zM22.91 7.335c0-.246-.06-.43-.164-.569-.12-.138-.315-.261-.6-.4-.705-.291-1.214-.583-1.53-.875-.314-.292-.479-.722-.479-1.306 0-.523.165-.938.51-1.276.345-.338.794-.522 1.364-.584v-.968h.705v.984c.54.077.959.307 1.274.676.315.369.465.845.45 1.429l-.015.015H22.94c0-.338-.06-.584-.194-.737a.567.567 0 0 0-.495-.246c-.21 0-.375.061-.465.2a.81.81 0 0 0-.15.507c0 .215.06.384.165.507.105.138.315.26.615.4.69.307 1.2.598 1.529.906.33.307.495.737.495 1.29 0 .538-.165.953-.495 1.291-.33.323-.765.523-1.32.569v.922h-.704v-.922c-.585-.062-1.064-.261-1.44-.615-.374-.353-.569-.876-.554-1.567l.015-.03h1.47c0 .383.074.644.24.814.164.169.374.245.629.245.21 0 .375-.061.495-.2a.76.76 0 0 0 .134-.46z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgActionTabBarBudgetIconOnlyDefault);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/action-tab-bar-budget-icon-only-default.5b32ed371a55483e9603773feb6008c2.svg";